<template>
  <div class="blog-subscription">
    <div class="blog-subscription__image">
      <img src="~~/assets/images/right-watch-cat.png" alt="right-watch-cat" />
    </div>
    <form
      id="subscription"
      name="subscription"
      class="blog-subscription__body"
      @submit.prevent="onSubscribe"
    >
      <div class="blog-subscription__title-w">
        <p class="blog-subscription__title">
          {{ _T("@Blog subscription title") }}
        </p>
        <p class="blog-subscription__caption">
          {{ _T("@Blog subscription caption") }}
        </p>
        <InputEmail v-model="email" :validate="v" caption="E-mail" />
      </div>
      <ButtonPrimary
        type="submit"
        :aria-label="_T('@Subscribe')"
        button-width="236px"
      >
        {{ _T("@Subscribe") }}
      </ButtonPrimary>
    </form>
  </div>
</template>

<script setup>
import ButtonPrimary from "~/modules/shared/buttons/ButtonPrimary.vue";
import { useAPI } from "~/uses/useMyFetch";
import { emailValidate, requiredValidate } from "~/utils/validators";
import useVuelidate from "@vuelidate/core";
import InputEmail from "~/modules/shared/inputs/InputEmail.vue";
import { useBlogStore } from "~/nuxt_modules/blog/store/blog.store.js";
import { unlocalizeRouteName } from "~/utils/strings.utils";
import { RouteNames } from "~/nuxt_modules/common/config/route.config";

const { getCategory, getTag } = useBlogStore();
const route = useRoute();

const blogletterMap = {
  [RouteNames.BLOG_HOME]: () => ({
    origin: "home",
  }),
  [RouteNames.BLOG_CATEGORY]: () => ({
    origin: "category",
    options: {
      documentId: getCategory(route.params.categorySlug).documentId,
    },
  }),
  [RouteNames.BLOG_TAG]: () => ({
    origin: "tag",
    options: {
      documentId: getTag(route.params.tagSlug).documentId,
    },
  }),
};

const email = ref("");

const rules = computed(() => ({
  required: requiredValidate(),
  email: emailValidate(),
}));

const v = useVuelidate(rules, email);

const onSubscribe = async () => {
  if (await v.value.$validate()) {
    useAPI("/marketing/blogletter", {
      method: "POST",
      body: {
        email: email.value,
        ...blogletterMap[unlocalizeRouteName(route.name)](),
      },
    }).then(() => {
      email.value = null;
      v.value.$reset();
    });
  }
};
</script>

<style scoped lang="scss">
.blog-subscription {
  @extend %width-main;

  @include flex-container(row, space-between, center);
  gap: 16px;

  border-radius: 32px;
  background-color: var(--color-blue-100);

  padding: 32px 32px 0;
  margin-inline: auto;

  @include bigMobile {
    flex-direction: column;

    padding-inline: 8px;
  }

  &__image {
    height: 160px;

    @include bigMobile {
      order: 1;
    }

    & > img {
      height: 100%;
    }
  }

  &__body {
    max-width: 940px;
    width: 100%;

    @include flex-container(row, space-between, center);
    gap: 16px;

    padding-bottom: 16px;

    @include bigMobile {
      flex-direction: column;
      padding-bottom: 0;
    }
  }

  &__title-w {
    width: 100%;
    max-width: 660px;

    @include flex-container(column, center, flex-start);
    gap: 16px;

    @include bigMobile {
      align-items: center;
      text-align: center;
    }
  }
}
</style>
